import { createReducer } from "redux-create-reducer";

import {
  GET_CLIENT_PROFILE_ENTRY_DETAILS,
  CLEAR_CLIENT_PROFILE_ENTRY_DETAILS,
} from "../types";

const initialState = {
  data: {},
  isLoading: false,
};

const clientProfileDetailsEntryDetailReducer = createReducer(initialState, {
  [GET_CLIENT_PROFILE_ENTRY_DETAILS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRY_DETAILS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_CLIENT_PROFILE_ENTRY_DETAILS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_CLIENT_PROFILE_ENTRY_DETAILS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [CLEAR_CLIENT_PROFILE_ENTRY_DETAILS]: () => initialState,
});

export default clientProfileDetailsEntryDetailReducer;



// WEBPACK FOOTER //
// ./src/features/client-profile/reducers/clientProfileEntryDetailsReducer.js